import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'EventUI',
      openMode: OpenModeType.sameFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EventUI/EventUI.vue'),
    },
    {
      name: 'OrderPointUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/OrderPointUI/OrderPointUI.vue'),
    },
    {
      name: 'OrderUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/OrderUI/OrderUI.vue'),
    },
    {
      name: 'PackagingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PackagingUI/PackagingUI.vue'),
    },
    {
      name: 'PointDetailsUI',
      openMode: OpenModeType.sameFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PointDetailsUI/PointDetailsUI.vue'),
    },
    {
      name: 'SegmentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SegmentUI/SegmentUI.vue'),
    },
    {
      name: 'TripOpsTrackingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TripOpsTrackingListUI/TripOpsTrackingListUI.vue'),
    },
    {
      name: 'TripUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TripUI/TripUI.vue'),
    },
  ],
}
